import styled, { css } from 'styled-components';

import { Container as SectionContainer } from './../SectionContainer/styles';
import { Title as Heading } from './../Heading/styles';

const menuVisible = () => css`
  visibility: visible;
  opacity: 1;
`;

export const Container = styled.div`
  position: fixed;
  z-index: 5;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  border-bottom: ${({ theme }) => theme.colors.mediumGray};
  background: ${({ theme }) => theme.colors.white};
  transition: all 300ms ease-in-out;

  > ${SectionContainer} {
    padding-top: 0;
    padding-bottom: 0;
  }

  & ${Heading} {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media ${({ theme }) => theme.media.lteMedium} {
    height: 100vh;
    visibility: hidden;
    opacity: 0;

    ${({ visible }) => visible && menuVisible()}

    > ${SectionContainer} {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      height: 100vh;
      align-items: center;
      overflow-y: auto;
    }

    & ${Heading} {
      padding-bottom: ${({ theme }) => theme.spacings.large};
      display: flex;
      justify-content: center;
    }
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${({ theme }) => theme.media.lteMedium} {
    display: block;
    text-align: center;
    padding: ${({ theme }) => theme.spacings.xxlarge} 0;
  }
`;

export const Button = styled.button`
  z-index: 6;
  position: fixed;
  top: 2rem;
  right: 2rem;
  width: 4rem;
  height: 4rem;
  background: ${({ theme }) => theme.colors.primaryColor};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  display: none;
  pointer-events: ${({ visible }) => (visible ? 'none' : 'all')};

  @media ${({ theme }) => theme.media.lteMedium} {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > svg {
    width: 2.5rem;
    height: 2.5rem;
  }
`;
